<template>
  <div>
    <div 
    :class="['pt-10 flex items-center justify-center']"
    >
      <div>
        <img
          class="object-cover"
          style="height: 18rem;"
          :src="
            menu.picture_url
              ? menu.picture_url
              : require('../assets/images/Menu.Logo.png')
          "
          alt="Logo"
        />
      </div>
      <div v-if="!menu.picture_url" class="text-2xl text-white ml-6">
        <p>QR MENU APP</p>
        <p class="text-5xl"
        :style="makeStyles(titleFont,titleTextTransform)"
        >
        {{ menu["name" + "_" + language] }}
      </p>
    </div>
  </div>
  <div class="flex items-center justify-center flex-col">
    <div class="text-center text-7xl font-bold tracking-tighter w-2/3 leading-none py-32">
        Scan the Como ID or your coupon
    </div>
    <div>
        <img :src="DownArrow" class="w-72 opacity-20" />
    </div>
  </div>
  <ClipLoader
      v-if="scannerLoading"
      color="black"
      size="50px"
      class="transform translate-y-1 pt-3"
      />
    <!-- Hidden input field  -->
    <div class="overflow-hidden width-0">
        <input ref="typeBox" type="" v-model="scannedData" placeholder="" @input="onScan" class="scanInputField" >
    </div>
    <div class="text-3xl flex justify-center flex-col absolute w-full bottom-0">
      <!-- Error message  -->
      <div class="text-center bg-gray-100" v-if="scanError">
        <button class="font-semibold py-6 "
        @click="handleComoError">
            Try Again
        </button>
      </div>
      <button @click="hide()" class="font-semibold py-6 bg-gray-300">
        Cancel
      </button>
  </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import lang from "../lang";
import IconCancel from "../components/icons/iconCancel.vue";
import DownArrow from "../assets/images/down-arrow.svg";
const ClipLoader = require("vue-spinner/src/ClipLoader.vue").default;
import _ from 'lodash';
export default {
  name: "ComoScanner",
    components: {ClipLoader},
    data() {
        return {
            lang,
            DownArrow,
            IconCancel,
            scannedData: '',
            scannerLoading: false,
            scanError: false,
        };
    },
    props: {
    orderType: {
      type: String,
    },
  },
    computed: {
        ...mapGetters([
            "menu",
            "identificationFormData",
            "language",
            "menuCategories",
            "currentHash",
        ]),
    },
    mounted() {
        this.$modal.hide("comoMember")
        this.$nextTick(() => this.$refs.typeBox.focus())
        this.scannedData = '';
        this.$store.commit("updateMember", "");
        this.scanError = false;
    },
    methods: {
        hide() {
            this.$modal.hide("comoScan");
        },
        onScan: _.debounce(function () {
        this.identificationFormData.customIdentifier = this.scannedData;
        this.scannerLoading = true
        this.$store.dispatch("GET_MEMBER_DETAILS").then(() => {
            sessionStorage.setItem("comoMemberCode",this.scannedData)
            sessionStorage.setItem("isLoyaltyMember","true")
            this.scannerLoading = false
            this.$modal.hide("comoScan")
            let type = this.orderType
            if (type === "take_away") this.$store.commit("Cart/updateHomeDelivery");
            this.$router.push({
                path: `/${this.currentHash}/sub/category/${this.menuCategories[0].Id}`,
                query:this.$route.query
            });
            this.getCategories(this.menuCategories[0]);
            this.$store.commit("updateCurrentKioskMode", lang[type][this.language]),
            this.$store.commit("updateCancelOrder", false);
            this.$store.commit("Cart/updateIsOrderTypeDineIn", type === "dine_in");
            this.addLocalstorage(lang[type]);
        })
            .catch(() => {
            this.scanError = true;
            this.scannerLoading = false
                });
        }, 600),
        handleComoError() {
        this.scannedData = '';
        this.$nextTick(() => this.$refs.typeBox.focus())
        this.$store.commit("updateMember", "");
        this.scanError = false;
        },
        // get the menu categories and push the router to the correct path
        getCategories(item) {
        this.$store.commit("updateSelectedMenuCategory", item);
        this.$store.commit("updateCategoryId", item.Id);
        this.$store.commit("updateIsSubSubCategory", false);
        if (item.hasSubCategories) {
            this.$store.commit("updateSubCategoryId", item.Id);
            this.$store.dispatch("GET_MENU_SUB_CATEGORIES");
            this.$store.commit("updateMenuCategoriesCategories", item);

            this.$router
            .push("/" + this.$route.params.menuHash + "/category/" + item.Id)
            .catch(() => {});
        } else {
            this.$store.dispatch("GET_CATEGORY");
            this.$router
            .push("/" + this.$route.params.menuHash + "/sub/category/" + item.Id)
            .catch(() => {});
        }
    },
    }
};
</script>

<style scoped>
.test .flex:last-child {
  border-bottom: none;
}
.scanInputField {
  opacity:0;
  filter:alpha(opacity=0);
}
</style>
